import { connect } from "react-redux"

import ContactFormView from "./contact-form-view"
import { showAlert } from "../../redux/alert/actions"

export default connect(null, { showAlert })(ContactFormView)
